{
	"translateEventStatus": {
		"canceled": "Canceled",
		"created": "Creado",
		"finished": "Completado",
		"running": "En proceso"
	},
	"translatePaymentMethod": {
		"anticipated": "Anticipado",
		"app": "App",
		"appPrePayment": "Pago via APP",
		"bonus": "Bonus",
		"cash": "Efectivo",
		"creditCard": "Tarjeta de crédito",
		"dashboard": "Dashboard",
		"debitCard": "Tarjeta de débito",
		"pix": "Pix",
		"postEvent": "Post evento",
		"rappi": "Rappi",
		"voucher": "Voucher",
		"zigPosCredit": "Zig post credit",
		"zigPosDebit": "Zig post debit",
		"integratedFoodVoucher": "Vale de Alimentación"
	}
}
